import { Card, CardContent } from '@mui/joy';

import { ExpandableSection } from 'core/components';
import { Color, DecoratorPosition, Variant } from 'theme/enums';

interface IProps {
  title: string;
  children: JSX.Element;
  color?: Color;
  variant?: Variant;
  defaultExpanded?: boolean;
  iconPosition?: DecoratorPosition;
}

export const ExpandableCard = ({
  title,
  children,
  color = Color.NEUTRAL,
  variant = Variant.PLAIN,
  defaultExpanded = false,
  iconPosition = DecoratorPosition.END,
}: IProps) => {
  return (
    <Card variant={variant} color={color} sx={{ width: '100%' }}>
      <CardContent sx={{ display: 'flex', gap: 1 }}>
        <ExpandableSection
          title={title}
          defaultExpanded={defaultExpanded}
          iconPosition={iconPosition}
        >
          {children}
        </ExpandableSection>
      </CardContent>
    </Card>
  );
};
